/* eslint-disable @typescript-eslint/naming-convention */
var NATIVE_PLATFORM_MAPPINGS = {
    iphone: "iphoneapp",
    ipad: "ipadapp",
    android: "android",
    outdated_app: "outdated_app",
};
var RENDERED_ON_MAPPINGS = {
    iphone: "webview",
    ipad: "webview",
    android: "webview",
    outdated_app: "webview",
    web: "browser",
};
/* eslint-enable @typescript-eslint/naming-convention */
export var createPlatform = function (_a) {
    var nativeClient = _a.nativeClient, responsiveLayout = _a.responsiveLayout;
    return {
        getName: function () {
            if (nativeClient) {
                return NATIVE_PLATFORM_MAPPINGS[nativeClient];
            }
            var isDesktopBrowser = responsiveLayout === "XL";
            return isDesktopBrowser ? "web" : "msite";
        },
        getRenderedOn: function () {
            return RENDERED_ON_MAPPINGS[nativeClient || "web"];
        },
    };
};
//# sourceMappingURL=platform.js.map